import React from "react";
import {
    EMPTY_STRING,
    pageLoadStates,
    TOTAL_DEFAULT_STEPS,
    TOTAL_FREEHAND_STEPS,
} from "../constants";
import LoadingScreen from "../components/__shared__/LoadingScreen";
import FailureScreen from "../components/__shared__/FailureScreen";
import { FREEHAND_SUMMARY_STEP } from "../components/CreateTPlan_1Upload/constants";
import CemFailureScreen from "../components/__shared__/CemFailureScreen";

export const interleave = (arr, arr2) =>
    arr.reduce((combArr, el, i) => combArr.concat(el, arr2[parseInt(i)]), []);

export function isEmpty(obj) {
    if (obj == null) {
        return true;
    }

    for (let key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}

export function hasProperty(obj, key) {
    if (!obj) {
        return false;
    }

    let keyArgs = key.split(".");
    for (let i = 0; i < keyArgs.length; i++) {
        if (
            obj == null ||
            !Object.prototype.hasOwnProperty.call(obj, keyArgs[parseInt(i)])
        ) {
            return false;
        }
        obj = obj[keyArgs[parseInt(i)]];
    }
    return true;
}

export function toQueryString(args) {
    if (args.length > 0) {
        return "?" + args.join("&");
    }

    return EMPTY_STRING;
}

export function traverseDirectory(entry, fileList) {
    const reader = entry.createReader();

    return new Promise((resolve, reject) => {
        const iterationAttempts = [];

        function readEntries() {
            reader.readEntries(
                (entries) => {
                    if (!entries.length) {
                        resolve(Promise.all(iterationAttempts));
                    } else {
                        iterationAttempts.push(
                            Promise.all(
                                entries.map((ientry) => {
                                    if (ientry.isFile) {
                                        fileList.push(ientry);
                                        return ientry;
                                    } else {
                                        return traverseDirectory(
                                            ientry,
                                            fileList
                                        );
                                    }
                                })
                            )
                        );

                        readEntries();
                    }
                },
                (error) => reject(error)
            );
        }

        readEntries();
    });
}

export function getLoadingScreen(state, mode, onRetry) {
    switch (state) {
        case pageLoadStates.LOADING: {
            return <LoadingScreen mode={mode} />;
        }
        case pageLoadStates.CEM_FAILED: {
            return <CemFailureScreen onClick={onRetry} />;
        }
        case pageLoadStates.FAILED: {
            return <FailureScreen />;
        }
        case pageLoadStates.COMPLETE: {
            return null;
        }
        default:
            return null;
    }
}

export function authPlanCompleteFunc(passedProps) {
    return !passedProps.flags.planCompleted;
}

export function authTokenFunc(passedProps) {
    return passedProps.flags.isAuthenticated;
}

export function getFreehandWorkflowAdjustedStep(step) {
    if (step >= TOTAL_DEFAULT_STEPS - TOTAL_FREEHAND_STEPS) {
        return FREEHAND_SUMMARY_STEP;
    }
    return step;
}

export const getSignedUrl = (urls) => (urls.length ? urls[0] : EMPTY_STRING);

export const toArray = (items) => {
    if (items.constructor === Array) {
        return items;
    } else {
        return [items];
    }
};

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function addPendoTracking(
    trackingEventName,
    planUUID,
    errMsg,
    otherData = {}
) {
    try {
        const eventData = { ...otherData };
        if (planUUID) {
            eventData.planId = planUUID;
        }
        if (errMsg) {
            eventData.message = errMsg;
        }

        window.pendo?.track(trackingEventName, eventData);
    } catch (err) {
        console.info("Pendo tracking failed: ", trackingEventName, errMsg, err);
    }
}

/**
 * Sanitizes user text input by stripping HTML tags and quotation marks
 * @param {string} text - The raw user input
 * @returns {string} - Sanitized text with HTML tags and quotation marks removed
 */
export function sanitizeUserText(text) {
    if (!text) return text;

    // Strip HTML tags using the browser's HTML parser (mirrors bluemonday.StrictPolicy())
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;
    let sanitized = tempDiv.textContent || tempDiv.innerText || "";

    // Remove straight and curly quotation marks
    sanitized = sanitized.replace(/["''\u201C\u201D\u2018\u2019]/g, "");

    return sanitized;
}

export function clearPendoSession() {
    try {
        window.pendo?.clearSession();
    } catch (err) {
        console.info("Failed to clear Pendo session: ", err);
    }
}
